import { gql } from '@apollo/client';
export const bulkUploadMutation = gql `
  mutation BulkUploadDocuments($input: UploadFileSystemDocumentInput!) {
    uploadFileSystemDocumentsAsync(input: $input) {
      id
    }
  }
`;
